import { render, staticRenderFns } from "./cModaladdPay.vue?vue&type=template&id=2835d47a&scoped=true"
import script from "./cModaladdPay.vue?vue&type=script&lang=js"
export * from "./cModaladdPay.vue?vue&type=script&lang=js"
import style0 from "./cModaladdPay.vue?vue&type=style&index=0&id=2835d47a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835d47a",
  null
  
)

export default component.exports